

define(['squid/index', 'text!./template.html', 'jquery'], function (squid, template, $) {
    squid.module('xo-tooltip.directive', ['squid']).directive('xoTooltip', function () {

        return {
            template: template,
            restrict: 'E',
            transclude: true,
            scope: {
                trigger: '@',
                showEvent: '@',
                hideEvent: '@',
                displayInline: '=',
                align: '@' // can take left/right
            },

            link: function link($scope, $element) {
                $($element).find('.toolTip').on('click', function (event) {
                    event.stopPropagation();
                });
            },

            controller: function controller($scope, $element, $timeout) {

                function isLink() {
                    return $($scope.trigger).is('a');
                }

                $timeout(function () {
                    var $trigger = $($scope.trigger);
                    var isMouseOver = false;
                    var toolTip = $($element).find('.toolTip');

                    var toolTipID = $scope.toolTipID = 'toolTip_' + Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 7);

                    $scope.showEvent = $scope.showEvent || (isLink() ? 'click' : 'focus');
                    $scope.hideEvent = $scope.hideEvent || 'blur';

                    $scope.toggle = function (event) {

                        if (event) {
                            event.stopPropagation();
                            event.preventDefault();
                        }

                        if (toolTip.length && $(toolTip).is(':visible')) {
                            $scope.close();
                        } else {
                            $scope.show();
                        }
                    };

                    $scope.show = function (event) {

                        if (event) {
                            event.stopPropagation();
                            event.preventDefault();
                        }

                        // Associate toolTipId with trigger element aria-describedby
                        var describedByIds;
                        if ($trigger.attr('aria-describedby')) {
                            describedByIds = $trigger.attr('aria-describedby').split(' ');
                        } else {
                            describedByIds = [];
                        }

                        if (!~describedByIds.indexOf(toolTipID)) {
                            describedByIds.push(toolTipID);
                        }

                        $trigger.attr('aria-describedBy', describedByIds.join(' '));

                        // Show the tooltip and position the page scroll to include the element on page
                        $($element).show();
                        $(toolTip).slideDown({
                            progress: function progress() {
                                var windowBot = $(window).scrollTop() + $(window).height();
                                var toolTipBot = toolTip.offset().top + toolTip.outerHeight();
                                if (toolTipBot > windowBot) {
                                    $(window).scrollTop(toolTipBot - $(window).height());
                                }
                            }
                        });
                    };

                    $scope.close = function (event) {
                        if (event) {
                            event.stopPropagation();
                            event.preventDefault();
                        }

                        if (!isMouseOver) {
                            if (toolTip.length && $(toolTip).is(':visible')) {
                                $(toolTip).slideUp(100, function () {
                                    $($element).hide();
                                });
                            } else {
                                $($element).hide();
                            }

                            // Remove tooltipId from aria-describedby
                            var describedByIds = $trigger.attr('aria-describedby');
                            if (describedByIds && ~describedByIds.indexOf(toolTipID)) {
                                describedByIds = describedByIds.split(' ').filter(function (id) {
                                    return id !== toolTipID;
                                });
                                $trigger.attr('aria-describedby', describedByIds.join(' '));
                            }
                        }
                    };

                    $($element).on('click', '.close', function (event) {
                        $scope.close(event);
                    });

                    $($element).on('mouseover', function (event) {
                        isMouseOver = true;
                    });

                    $($element).on('mouseleave', function (event) {
                        isMouseOver = false;
                    });

                    $(document).on('click.toolTip', function (event) {
                        $scope.close();
                    });

                    if (isLink()) {
                        $trigger.on('click.toolTip', $scope.toggle);
                        $trigger.on('blur.toolTip', $scope.close);
                    } else if ($scope.showEvent === $scope.hideEvent) {
                        $trigger.on($scope.showEvent + '.toolTip', function (event) {
                            $scope.toggle(event);
                        });
                    } else {
                        $trigger.on($scope.showEvent + '.toolTip', function (event) {
                            $scope.show(event);
                        });

                        $trigger.on($scope.hideEvent + '.toolTip', function (event) {
                            $scope.close(event);
                        });
                    }

                    // Clean up document listener on close
                    $scope.$on('$destroy', function () {
                        $(document).off('click.toolTip');
                        $trigger.off($scope.showEvent + '.toolTip');
                        $trigger.off($scope.hideEvent + '.toolTip');
                        $scope.close();
                    });
                }, 50);
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-ui-components/src/tooltip/directive.js
 ** module id = 225
 ** module chunks = 1
 **/